import { css, styled } from 'styled-components'

import { Button } from '@b-stock/fe-core/bstock-react'
import { Colors, Typography } from '@b-stock/fe-core/design-system'

const statBaseStyles = css`
  ${Typography.Body3}
  align-items: center;
  background-color: ${Colors.Semantic.Neutral.white};
  color: ${Colors.Semantic.Neutral.dark_grey};
  display: inline-flex;
  gap: 0.5rem;
  padding: 0;

  &:hover svg {
    color: ${Colors.Semantic.BStock.onhover};
  }
`

export const Stat = styled.div<{ $warning?: boolean }>`
  ${statBaseStyles}

  ${(o) =>
    o.$warning &&
    css`
      color: ${Colors.Semantic.Warning.onclick};

      svg {
        color: ${Colors.Semantic.Warning.onclick};
      }
    `}
`

export const StatButton = styled(Button)`
  &&& {
    ${statBaseStyles}
  }
`
